import { Editor } from '@tiptap/core'
import { MarkType } from '@tiptap/pm/model'

export type MarkRange = {
  from: number
  to: number
}
// based on the example at: https://discuss.prosemirror.net/t/expanding-the-selection-to-the-active-mark/478/9
export default function getMarkRange(editor: Editor, pos: number, type: string | MarkType): MarkRange | null {
  const $pos = editor.state.doc.resolve(pos)

  if (!$pos || !type) {
    return null
  }

  const start = $pos.parent.childAfter($pos.parentOffset)

  if (!start.node) {
    return null
  }

  const link = start.node.marks.find((mark) => mark.type === type)

  if (!link) {
    return null
  }

  let startIndex = $pos.index()
  let startPos = $pos.start() + start.offset
  let endIndex = startIndex + 1
  let endPos = startPos + start.node.nodeSize

  while (startIndex > 0 && link.isInSet($pos.parent.child(startIndex - 1).marks)) {
    startIndex -= 1
    startPos -= $pos.parent.child(startIndex).nodeSize
  }

  while (endIndex < $pos.parent.childCount && link.isInSet($pos.parent.child(endIndex).marks)) {
    endPos += $pos.parent.child(endIndex).nodeSize
    endIndex += 1
  }

  return {
    from: startPos,
    to: endPos,
  }
}
